import React, { FC } from 'react';
import { styled } from '@mui/material/styles';
import { IconButton } from '@mui/material';
import { GridApiPro, gridFilteredSortedRowIdsSelector, gridVisibleColumnDefinitionsSelector } from '@mui/x-data-grid-pro';
import { newestAssessment, Revision } from './types';
import { utils, writeFile } from 'xlsx';

const PREFIX = 'ExcelExport';

const classes = {
  excelButton: `${PREFIX}-excelButton`,
  excelIcon: `${PREFIX}-excelIcon`,
};

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  [`&.${classes.excelButton}`]: {
    position: 'absolute' as 'absolute',
    right: theme.spacing(4),
    top: theme.spacing(12),
  },

  [`& .${classes.excelIcon}`]: {
    width: 24,
    height: 24,
  },
}));

export const ExcelExport: FC<{ apiRef: React.MutableRefObject<GridApiPro> }> = ({ apiRef }) => {
  const handleExport = () => {
    exportFile(apiRef);
  };

  return (
    <StyledIconButton className={classes.excelButton} onClick={handleExport} title="Eksport til Excel" size="large">
      <img src="/icons8-microsoft-excel.svg" className={classes.excelIcon} alt="Excel icon" />
    </StyledIconButton>
  );
};

function exportFile(apiRef: React.MutableRefObject<GridApiPro>) {
  const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
  const rows = filteredSortedRowIds.map((id) => apiRef.current.getRow(id) as Revision);
  const visibleColumns = gridVisibleColumnDefinitionsSelector(apiRef);

  if (!rows) {
    return;
  }

  const headings: string[] = visibleColumns?.map((col) => col.headerName?.toString() || col.field) ?? [];

  const data: string[][] = rows.map((item) => {
    if (!item) return [];
    return (
      visibleColumns?.map((col) => {
        const key = col.field as keyof Revision;
        const value = item[key];
        const gridColKey = col.field;
        switch (gridColKey) {
          case 'projectLeadAssessments':
            return newestAssessment(item)?.text ?? '';
          case 'progressResponsibility':
            return col.valueFormatter!(col.valueGetter!(value as never, item, col, apiRef) as never, item, col, apiRef);
          default:
            if (col.valueGetter) {
              return col.valueGetter(value as never, item, col, apiRef);
            }
            return value ?? '';
        }
      }) ?? []
    );
  });
  data.unshift(headings);
  const sheet = utils.aoa_to_sheet(data);
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, sheet, 'Revisioner');
  writeFile(workbook, 'revisjoner.xlsx');
}
